import Auction from '~/App/shared/interfaces/Auction';
import { useDispatch, useSelector } from 'react-redux';
import { favouriteAuctions as favouriteAuctionsSelector } from '~/App/shared/selectors/global';
import { toggleFavourite as toggleFavouriteAction } from '~/App/shared/actions/favouriteAuctions';

const useProductCardIconsProps = (auction: Auction) => {
  const dispatch = useDispatch();
  const favouriteAuctions = useSelector(favouriteAuctionsSelector);

  const toggleFavourite = () => {
    dispatch(toggleFavouriteAction(auction.id));
  };

  return {
    isFavourite: favouriteAuctions.includes(auction.id),
    toggleFavourite
  };
};

export default useProductCardIconsProps;
